import { RootState } from "@/modules/common";

export const selectActiveDiscount = (state: RootState) =>
  state.basket.basket.activeDiscount;
